// WeakMap: host -> WeakMap: effectFn -> {actionType: value}
export default new WeakMap();
